import { ResubmitIndicationButton, ResubmitLabel } from '@/components/Chat/ResubmitIndicationButton'
import { Card, CardAction, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Vendor } from '@/models/insuranceTypes'

/** Staff-only stand-in for a direct Progressive card that has never been run on this application. */
export function ProgressiveNotRunCard({ applicationId, orgId }: { applicationId: string; orgId?: string }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Progressive</CardTitle>
        <CardDescription>Not run yet for this application.</CardDescription>
        <CardAction>
          <ResubmitIndicationButton
            vendor={Vendor.PROGRESSIVE}
            vendorName="Progressive"
            applicationId={applicationId}
            orgId={orgId}
            label={ResubmitLabel.SUBMIT}
          />
        </CardAction>
      </CardHeader>
    </Card>
  )
}
